export default (context, payload) => {
    const setAttribute = payload.oneLni.storeUtils.setAttribute;

    const visible = context.rootState[payload.targetId].value === 'YES';
    setAttribute(context, `${payload.sourceId}_other-agency_collapse`, 'visible', visible);

    if (!visible) {
        setAttribute(context, `${payload.sourceId}_other-agency_details`, 'value', '');
    }
};